var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8.2C3.2.2.2,3.2.2,6.8v10.6c0,3.7,3,6.6,6.6,6.6h10.6c3.7,0,6.6-3,6.6-6.6V6.8c0-3.7-3-6.6-6.6-6.6H6.8ZM6.8,2.9h10.6c2.2,0,4,1.8,4,4v10.6c0,2.2-1.8,4-4,4H6.8c-2.2,0-4-1.8-4-4V6.8c0-2.2,1.8-4,4-4ZM18.8,4.2c-.7,0-1.3.6-1.3,1.3s.6,1.3,1.3,1.3,1.3-.6,1.3-1.3-.6-1.3-1.3-1.3ZM12.1,5.5c-3.7,0-6.6,3-6.6,6.6s3,6.6,6.6,6.6,6.6-3,6.6-6.6-3-6.6-6.6-6.6ZM12.1,8.2c2.2,0,4,1.8,4,4s-1.8,4-4,4-4-1.8-4-4,1.8-4,4-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.8cf4801713047d2db83e202d63ce3453.svg";
export { ForwardRef as ReactComponent };